import QuestionnaireResponseRecipes_1_0_0 from './QuestionnaireResponseRecipes_1_0_0.js';
import QuestionnaireResponseRecipes_2_0_0 from './QuestionnaireResponseRecipes_2_0_0.js';
const QuestionnaireResponseRecipes = [
    ...QuestionnaireResponseRecipes_1_0_0,
    ...QuestionnaireResponseRecipes_2_0_0
];
export default QuestionnaireResponseRecipes;
export const latestQuestionnaireResponsesVersion = 'QuestionnaireResponses_2_0_0';
export const latestQuestionnaireResponseVersion = 'QuestionnaireResponse_2_0_0';
const supportedResponses = ['QuestionnaireResponses', 'QuestionnaireResponses_2_0_0'];
export const QuestionnaireResponsesVersions = [
    ...supportedResponses
];
export const QuestionnaireResponsesVersionsTypes = [...supportedResponses];
const supportedResponse = ['QuestionnaireResponse', 'QuestionnaireResponse_2_0_0'];
//# sourceMappingURL=QuestionnaireResponseRecipes.js.map